"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ConditionBuilder_1 = __importDefault(require("./ConditionBuilder"));
var NotOperator_1 = __importDefault(require("../operators/NotOperator"));
var IntermediateContextHolder = (function () {
    function IntermediateContextHolder(context) {
        this.context = context;
    }
    IntermediateContextHolder.prototype.performPendingOperation = function (currentCondition) {
        var rCondition = this.context.invert
            ? (0, NotOperator_1.default)(currentCondition)
            : currentCondition;
        return new ConditionBuilder_1.default(this.context.pendingOperation
            ? this.context.pendingOperation.operation(this.context.pendingOperation.condition, rCondition)
            : rCondition);
    };
    return IntermediateContextHolder;
}());
exports.default = IntermediateContextHolder;
